<template>
  <div v-Clickoutside="handleClose" class="tree-select">
    <el-input
      :id="id"
      :name="name"
      ref="reference"
      :title="query"
      v-model="query"
      :placeholder="currentPlaceholder"
      :validate-event="false"
      @focus="handleFocus"
      @blur="handleBlur"
      @keydown.native.esc.stop.prevent="handleClose"
      @keydown.native.tab="handleClose"
      @keyup.native="filterData"
      @paste.native="filterData"
      @input.native="filterData"
      @mouseenter.native="labelInputHover = true"
      @mouseleave.native="labelInputHover = false"
      :disabled="disabled"
    >
      <i
        v-if="clearable && labelInputHover && !disabled"
        slot="suffix"
        class="el-icon-circle-close el-input__icon"
        @click.stop.prevent="clearData"
      />
      <i
        v-else-if="!disabled"
        slot="suffix"
        class="select-caret"
        :class="['el-select__caret', 'el-input__icon', 'el-icon-' + iconClass]"
        @click.stop.prevent="visible = !visible"
      />
    </el-input>
    <transition name="el-zoom-in-top" @after-leave="doDestroy">
      <el-select-menu v-show="visible" ref="popper" :appendToBody="true" :style="selectClass" class="main-tree-container">
        <div class="main-box">
          <div class="data-list" v-if="showTabs">
            <span class="item" :class="{'active':item.value==curTab}" v-for="item in tabList" :key="item.value" @click="changeTab(item)">{{item.label}}</span>
          </div>
          <el-scrollbar
            ref="scrollbar"
            tag="div"
            wrap-class="el-select-dropdown__wrap"
            view-class="el-select-dropdown__list"
          >
            <div class="tree-boxs">
              <el-tree
                ref="elTree"
                :filter-node-method="filterNode"
                :data="dataArr"
                :props="defaultProps"
                @node-click="nodeClick"
                :show-checkbox="isMultiple"
                :multiple="isMultiple"
                @check="checked"
                :check-strictly="checkStrictly"
                :node-key="defaultProps.key"
                :empty-text="emptyText"
                :expand-on-click-node="false"
                :default-expand-all="defaultExpand"
                :default-checked-keys="defaultChecked"
                :render-content="renderContent"
                style="padding-right:5px;"
                @node-contextmenu="rightClick"
              >
                <span class="custom-tree-node" slot-scope="{ node }">
                  <span :class="{'active': node.key === value}">{{ node.label }}</span>
                </span>
              </el-tree>
            </div>
          </el-scrollbar>
        </div>
      </el-select-menu>
    </transition>
  </div>
</template>
<script>
/***
 * v-model 绑定数据
 * data 传入树数据
 * 
 */
import {
  addResizeListener,
  removeResizeListener
} from 'element-ui/lib/utils/resize-event';
import Clickoutside from 'element-ui/lib/utils/clickoutside';
import Emitter from 'element-ui/lib/mixins/emitter';
import ElSelectMenu from './SelectDropdown.vue';
import utils from '@/utils/common.js';
export default {
  name: 'TreeSelect',
  componentName: 'ElFormItem',
  components: {
    ElSelectMenu
  },
  directives: {
    Clickoutside
  },
  mixins: [Emitter],
  props: {
    checkStrictly:{
      type:Boolean,
      default: false
    },
    value: { // 通过v-model绑定
      required: true
    }, // 传入的选中值,请用v-model绑定
    noDataText: String, // 无数据显示文本
    id: String, // input id
    name: String, // input name
    placeholder: String,
    clearable: { // 是否可清除
      type: Boolean,
      default: true
    },
    showTabs: { // 是否可清除
      type: Boolean,
      default: false
    },
    defaultExpand: {
      type: Boolean,
      default: true
    },
    isMultiple: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    },
    defaultChecked: {
      type: Array,
      default: () => {
        return []
      }
    },
    tabList: {
      type: Array,
      default: () => {
        return []
      }
    },
    data: { // 下拉树数据
      type: Array,
      default: () => {
        return []
      }
    },
    buildData: { // 下拉树数据
      type: Object,
      default: () => {
        return {}
      }
    },
    defaultProps: { // 下拉树配置选项
      type: Object,
      default: () => {
        return {
          children: 'children',
          label: 'configName',
          key: 'id',
          disabled: 'disabled'
        }
      }
    },
    //是否只有叶子节点可以选择
    onlyLeafSelect: {
      type: Boolean,
      default: false
    },
    // 针对报警新增的参数
    isAlarm:{
      type: Boolean,
      default: false
    },
    //判断是不是设备管理页面进来的
    isDeviceManage:{
      type: Boolean,
      default: false
    },
    isOnlyLeafSelect: {
      type: Boolean,
      default: false
    },
    //展示的数据中是否包含父元素
    showParentData: {
      type: Boolean,
      default: true
    },
    isSparePart: {
      type: Boolean,
      default: false
    },
    index: {
      type: Number,
      default: 0
    },
    title:{
      type:String,
      default:'项目'
    }
  },
  data () {
    return {
      labelInputHover: false,
      inputWidth: 0,
      dataArr: [],
      query: '',
      currentPlaceholder: '',
      visible: false,
      selectClass: {},
      checkedData:[]
    }
  },
  computed: {
    emptyText () {
      if (!this.query && this.query !== 0) return this.noDataText || '暂无数据';
      return this.noMatchText || '无匹配数据';
    },
    selected () {
      let option = {}
      const dataArr = this.getAllItemArr(this.dataArr)
      let valueData=this.value?String(this.value).includes(',')?this.value.split(','):[this.value]:[]
      let nowData=[]
      valueData.forEach(item=>{
        if(item!=''){
          nowData.push(item)
        }
      })
      // console.log(valueData,this.value,nowData.join(','))
      for (let index = 0, len = dataArr.length; index < len; index++) {
        if (nowData.join(',') == dataArr[index][this.defaultProps.key]) {
          option = dataArr[index]
          break;
        }
      }
      return option
    },
    iconClass () {
      // 输入框后缀样式
      return this.visible ? 'arrow-up' : 'arrow-down';
    }
  },
  created () {
    if (Array.isArray(this.value)) {
      this.clearData();
    }
    this.currentPlaceholder = this.placeholder;
  },
  methods: {
    changeTab(item){
      this.curTab=item.value;
      let data=[]
       this.buildData[this.curTab].dataArr.forEach(item=>{
           if(item!=undefined){
             data.push(item)
           }
          })
        this.dataArr=data
    },
    filterNode (value, data) {
      // 节点树过滤方法
      if (!value) return true;
      return data[this.defaultProps.label].indexOf(value) !== -1;
    },
    renderContent (h, { node, data, store }) {
      return (
        <span class="el-tree-node__label" title={node.label}>
          {node.label}
        </span>
      );
    },
    // 右键选中全选反选
    rightClick(event, data, node, cur){
      // 仅多选+非关联模式下生效
      if(!this.checkStrictly || !this.isMultiple) {
        return
      }
      // console.log(event, data, node, cur,this.isMultiple,"rightClick")
      let curItem = [...this.$refs.elTree.getCheckedKeys()];
      var length = 0;
      // 子节点选中数量
      node.childNodes.forEach(n => {
        if (n.checked) {
          length++;
        }
      });
      // 全部选中，反选
      if(node.checked && length == node.childNodes.length) {
        // 当前节点
        curItem.splice(curItem.indexOf(node.key), 1)
        // 子节点
        if(node.childNodes.length>0){
          node.childNodes.forEach(n => {
            if (n.checked) {
              curItem.splice(curItem.indexOf(n.key), 1)
            }
          }); 
        }
      } 
      // 其他情况，全选下一级
      else {
        // 当前节点
        if(curItem.indexOf(node.key) == -1){
          curItem.push(node.key)
        }
        // 子节点
        if(node.childNodes.length>0){
          node.childNodes.forEach(n => {
            if (!n.checked) {
              curItem.push(n.key)
            }
          }); 
        }
      }
      // 处理结果
      this.$refs.elTree.setCheckedKeys(curItem)
      this.$emit('input', curItem.join(',')||'');
      this.query = curItem.length > 1? `已选择${curItem.length}个${this.title}` : node[this.defaultProps.valueKey || this.defaultProps.label]
    },
    nodeClick (data, node) {
      // console.log(node)
      if (this.isMultiple) { return false }
      //  console.log(node.isLeaf&&data[this.defaultProps.key]==undefined)
      if(this.onlyLeafSelect){
        if(!node.isLeaf&&(data[this.defaultProps.key]==undefined || data[this.defaultProps.key]==-1)){
          this.query='';
          return;
        }
      }
      // this.isAlarm&&!data.deviceType
      // if(this.isAlarm&&!data.deviceType){
      //       this.query='';
      //       return;
      //   }
      // console.log(node,111111111,this.value,data[this.defaultProps.disabled])
      // if (node.key === this.value || data[this.defaultProps.disabled]) return;
      if ( data[this.defaultProps.disabled]) return;
      this.$emit('input', node.key)
      this.$emit('change', node, data, this.index)
      this.dispatch('ElFormItem', 'el.form.change', node.key);
      this.query = node.label
      this.visible = false
    },
    checked (data, node) {
      // console.log(node,7878)
      if(this.showTabs){
        let check=[];
        let nodeArr=[]
        node.checkedKeys.forEach((item,i)=>{
          if(item!=undefined){
            check.push(item)
          }
        })
        node.checkedNodes.forEach(item=>{
          if(item.id){
            nodeArr.push(item)
          }
        })
        this.$emit('change', check,nodeArr)
        this.query=check.length>1?`已选择${check.length}个${this.title}`:check.length==0?'请选择':nodeArr[0][this.defaultProps.valueKey || this.defaultProps.label]
      }else{
         let key = '';
         let newData=[]
         if(node.checkedKeys.length>1){
           node.checkedKeys.forEach(item=>{
             if(item!=''){
               newData.push(item)
             }
           })
           let newDataCopy=newData.filter(item=>{return item})
           key=newDataCopy.join(',')
         }else{
            key= node.checkedKeys[0]!=''||node.checkedKeys[0]!=undefined?node.checkedKeys[0]:''
         }
         this.$emit('input', key)
         this.$emit('change', node, data, key)
        //  console.log(node,key,'xuanz')
         if(!this.showParentData){
          let length=node.checkedKeys.length;
          let checkedData=[]
          node.checkedKeys.forEach((item,ind)=>{
            if(item!=undefined){
              checkedData.push(item)
            }
          })
          this.checkedData=checkedData
          this.query = checkedData.length > 1 ? `已选择${checkedData.length}个${this.title}` :length>0? node.checkedNodes[0][this.defaultProps.valueKey || this.defaultProps.label]:''
         }else{
           this.checkedData=node.checkedKeys.filter(item=>{return item!=undefined})
            this.query = this.checkedData.length > 1 ? `已选择${this.checkedData.length}个${this.title}` : node.checkedNodes[0][this.defaultProps.valueKey || this.defaultProps.label]
         }
      }
    },
    clearData () { // 清除数据
      this.query = ''
      this.$emit('input', '')
      this.$emit('change', null)
      this.dispatch('ElFormItem', 'el.form.change', '');
      if(this.$refs.elTree)this.$refs.elTree.setCheckedKeys([]);
      this.currentPlaceholder = this.placeholder
    },
    handleFocus () {
      this.visible = true
      this.query = ''
      // console.log(this.defaultChecked,this.checkedData,255588,this.selected)
      this.currentPlaceholder = this.isMultiple && this.checkedData.length > 1 ? `已选择${this.checkedData.length}个${this.title}` : this.selected[this.defaultProps.valueKey || this.defaultProps.label]? this.selected[this.defaultProps.valueKey || this.defaultProps.label] || this.placeholder:this.defaultChecked.length?`已选择${this.defaultChecked.length}个${this.title}`:''
    },
    handleBlur () {
      //  console.log(this.selected,9898989,this.defaultChecked)
      this.query = this.isMultiple && this.checkedData.length > 1 ? `已选择${this.checkedData.length}个${this.title}` :this.selected[this.defaultProps.valueKey || this.defaultProps.label]? this.selected[this.defaultProps.valueKey || this.defaultProps.label] || this.placeholder:this.defaultChecked.length?`已选择${this.defaultChecked.length}个${this.title}`:''
      this.currentPlaceholder = this.placeholder
    },
    handleClose () {
      this.visible = false
    },
    doDestroy () {
      this.broadcast('ElSelectDropdown', 'destroyPopper');
    },
    filterData () {
      // 过滤树节点数据
      this.$refs.elTree && utils.debounce(this.$refs.elTree.filter(this.query));
    },
    resetInputWidth () {
      if (this.$refs.reference && this.$refs.reference.$el) {
        this.inputWidth = this.$refs.reference.$el.getBoundingClientRect().width;
        this.$nextTick(_ => {
          this.broadcast('ElSelectDropdown', 'updatePopper');
        })
      }
    },
    getAllItemArr (data = this.dataCopy) {
      // 获取所有树节点
      let allArr = [];
      data.forEach(item => {
        if (item[this.defaultProps.children] && item[this.defaultProps.children].length) {
          allArr.push(JSON.parse(JSON.stringify(item)));
          const itemArr = this.getAllItemArr(item[this.defaultProps.children]);
          allArr = allArr.concat(itemArr);
        } else if (!item[this.defaultProps.children]||item[this.defaultProps.children].length==0) {
          allArr.push(item);
        }
      }, this);
      return allArr;
    }
  },
  watch: {
    value (val, oldVal) {
      console.log(val,9999)
      if (Array.isArray(val)) {
        this.clearData()
      }
       let dataArr=[]
          if(val){
            dataArr=this.isDeviceManage?[val]:String(val).includes(',')?val.split(','):[val];
          }
        let copyData=[]
         dataArr.forEach((item,ind)=>{
            if(item!=''){
              copyData.push(item)
            }
          })
        // console.log(dataArr,copyData,this.selected,89999,val)
      // let length = this.isMultiple && String(val).split(',').length > 1 ? val.split(',').length : 1
      this.query = this.isMultiple && copyData.length > 1 ? `已选择了${copyData.length} 个${this.title}` :copyData.length==1? this.selected[this.defaultProps.valueKey || this.defaultProps.label]:''
      // console.log(this.selected,5555,copyData,this.selected[this.defaultProps.label])
    },
    visible (val) {
      if (!val) {
        this.broadcast('ElSelectDropdown', 'destroyPopper');
      } else {
        // console.log(this.$refs.popper)
        this.selectClass = { width: this.$refs.reference.$el.clientWidth + 'px', 'whiteSpace': 'nowrap',
          'overflow': 'hidden',
          'textOverflow': 'ellipsis'}
        // this.$refs.popper.style.width = this.$refs.reference.$el.clientWidth + 'px';
        this.broadcast('ElSelectDropdown', 'updatePopper');
      }
    },
    data: {
      immediate: true,
      handler: function (val) {
        // console.log(79797979)
        this.dataArr = JSON.parse(JSON.stringify(val))
        this.broadcast('ElSelectDropdown', 'updatePopper');
        this.query = this.isMultiple && this.defaultChecked.length > 1 ? `已选择了${this.defaultChecked.length} 个${this.title}` : this.selected[this.defaultProps.valueKey || this.defaultProps.label]
      }
    },
    tabList:{
      immediate:true,
      handler:function(val){
        if(val.length>0){
          this.curTab=val[0].value;
        }
      }
    },
    buildData:{
      immediate:true,
      handler:function(val){
        if(JSON.stringify(val)!='{}'){
           let data=[]
          val[this.curTab].dataArr.forEach(item=>{
            if(item!=undefined){
              data.push(item)
            }
            })
          this.dataArr=data
        }

      }
    },
    defaultChecked(val){
      console.log(1255,val)
      if(val&&this.$refs.elTree){
        this.$refs.elTree.setCheckedKeys(val)
      }
    }
  },
  mounted () {
    addResizeListener(this.$el, this.resetInputWidth);
    const reference = this.$refs.reference;
    this.$nextTick(() => {
      if (reference && reference.$el) {
        this.inputWidth = reference.$el.getBoundingClientRect().width;
      }
    });
  },
  beforeDestroy () {
    this.doDestroy()
    if (this.$el && this.resetInputWidth) {
      removeResizeListener(this.$el, this.resetInputWidth);
    }
  }
}
</script>
<style lang="scss" scoped>
.tree-select {
  display: inline-block;
  line-height: normal;
  width: 100%;
  .el-input__icon {
    cursor: pointer;
  }
  .tree-boxs {
    ::v-deep .el-tree {
      padding-right: 3px;
    }
    ::v-deep .el-tree-node__label {
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    }
  }
}
.tree-select-dropdown {
  .active {
    color: #1989fa;
  }
}
.main-tree-container{
  width:220px !important;
}
.data-list{
  width: 100%;
  line-height: 28px;
  display: flex;
  justify-content: center;
  .item{
    flex:1;
    display: inline-block;
    padding:0px 3px;
    text-align: center;
    &.active{
      color:#fff;
      background: #1881BF;
    }
  }
}
</style>
<style lang="scss">
.tree-boxs {
  ::v-deep .el-tree-node__label {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
}
</style>